import * as React from 'react';
import ReactPlaceholder from 'react-placeholder/lib/ReactPlaceholder';

import { PlaceholderItemProps } from './PlaceholderItem.interfaces';

class PlaceholderItem extends React.Component<PlaceholderItemProps> {
  render() {
    const {
      showLoadingAnimation = true,
      type = 'text',
      rows = 1,
      classes,
      customPlaceholder,
    } = this.props;

    if (customPlaceholder) {
      return (
        <ReactPlaceholder
          ready={false}
          showLoadingAnimation={showLoadingAnimation}
          customPlaceholder={customPlaceholder as React.ReactElement}
        >
          <div />
        </ReactPlaceholder>
      );
    } else {
      return (
        <ReactPlaceholder
          className={classes.root}
          showLoadingAnimation={showLoadingAnimation}
          type={type}
          ready={false}
          rows={rows}
          color="#E0E0E0"
        >
          <div />
        </ReactPlaceholder>
      );
    }
  }
}

export default PlaceholderItem;
